const englishTabs = {
    dashboard: "Dashboard",
    dailyEntry: "DailyEntry",
    accounts: "Accounts",
    cashControl: "Cash Control",
    hrPayroll: "HrPayroll",
    purchases: "Purchases",
    sales: "Sales",
    expenses: "Expenses",
    stock: "Stock",
    inventory: "Inventory",
    reports: "Reports",
    tools: "Tools",
    settings: "Settings",
    retail: "Retail",
};


const arabicTabs = {
    dashboard: "لوحة التحكم",
    dailyEntry: "القيود اليومية",
    accounts: "الحسابات",
    cashControl: "إدارة النقد",
    hrPayroll: "الموارد البشرية",
    purchases: "المشتريات",
    sales: "المبيعات",
    expenses: "المصروفات",
    stock: "المخزون",
    inventory: "الجرد",
    reports: "التقارير",
    tools: "الأدوات",
    settings: "الإعدادات",
    retail: "التجزئة",
};

const frenchTabs = {
    dashboard: "Tableau de bord",
    dailyEntry: "Écritures journalières",
    accounts: "Comptes",
    cashControl: "Contrôle de caisse",
    hrPayroll: "RH & Paie",
    purchases: "Achats",
    sales: "Ventes",
    expenses: "Dépenses",
    stock: "Stock",
    inventory: "Inventaire",
    reports: "Rapports",
    tools: "Outils",
    settings: "Paramètres",
    retail: "Vente au détail",
};

const spanishTabs = {
    dashboard: "Tablero",
    dailyEntry: "Asientos diarios",
    accounts: "Cuentas",
    cashControl: "Control de caja",
    hrPayroll: "RRHH y Nómina",
    purchases: "Compras",
    sales: "Ventas",
    expenses: "Gastos",
    stock: "Stock",
    inventory: "Inventario",
    reports: "Informes",
    tools: "Herramientas",
    settings: "Configuraciones",
    retail: "Venta al por menor",
};

const portugueseTabs = {
    dashboard: "Painel",
    dailyEntry: "Lançamentos diários",
    accounts: "Contas",
    cashControl: "Controle de caixa",
    hrPayroll: "RH e Folha",
    purchases: "Compras",
    sales: "Vendas",
    expenses: "Despesas",
    stock: "Estoque",
    inventory: "Inventário",
    reports: "Relatórios",
    tools: "Ferramentas",
    settings: "Configurações",
    retail: "Varejo",
};

const brazilianPortugueseTabs = {
    dashboard: "Painel de Controle",
    dailyEntry: "Lançamentos Diários",
    accounts: "Contas",
    cashControl: "Controle de Caixa",
    hrPayroll: "RH e Folha de Pagamento",
    purchases: "Compras",
    sales: "Vendas",
    expenses: "Despesas",
    stock: "Estoque",
    inventory: "Inventário",
    reports: "Relatórios",
    tools: "Ferramentas",
    settings: "Configurações",
    retail: "Varejo",
};




const englishPages = {
    salesDashboard: "salesDashboard",
    chartOfAccount: "ChartOfAccount",
    myAccounts: "MyAccounts",
    groups: "Groups",
    delivery: "Delivery",

    cashAccount: "Cash Account",
    varianceAccount: "Variance Account",
    cashTransfer: "Cash Transfer",
    payments: "Payments",
    receipts: "Receipts",

    employee: "Employee",
    salary: "Salary",

    supplier: "Supplier",
    purchaseInvoice: "Purchase Invoice",
    purchaseReturn: "Purchase Return",
    purchaseOrder: "Purchase Order",

    customer: "Customer",
    salesInvoice: "Sales Invoice",
    salesReturn: "Sales Return",
    salesOrder: "Sales Order",

    expenseAccount: "Expense Account",
    expenseSupplier: "Expense Supplier",
    expenseInvoice: "Expense Invoice",

    stockControl: "Stock Control",
    stockTransfer: "Stock Transfer",
    stockCount: "Stock Count",

    products: "Products",
    categories: "Categories",
    brands: "Brands",
    seasons: "Seasons",
    vatGroup: "VatGroup",

    financial: "Financial",
    operational: "Operational",
    stockReport: "Stock Report",
    sessions: "Sessions",
    validation: "Validations",

    //tools
    stockTools: "Stock Tools",
    openingYear: "Opening Year",
    posTools: "PosTools",
    import: "Import",
    backup: "Backup",

    //settings
    general: "General",
    user: "User",
    role: "Role",
    linkAccount: "Link Account",
    currency: "Currency",

    //retail
    pos: "POS",

};


const arabicPages = {
    salesDashboard: "جدول المبيعات",
    chartOfAccount: "دليل الحسابات",

    myAccounts: "حساباتي",
    groups: "المجموعات",
    delivery: "التوصيل",

    cashAccount: "حساب النقدية",
    varianceAccount: "حساب الفروقات",
    cashTransfer: "تحويل نقدي",
    payments: "المدفوعات",
    receipts: "الإيصال",

    employee: "الموظف",
    salary: "الراتب",

    supplier: "المورد",
    purchaseInvoice: "فاتورة الشراء",
    purchaseReturn: "إرجاع الشراء",
    purchaseOrder: "طلب الشراء",

    customer: "العميل",
    salesInvoice: "فاتورة المبيعات",
    salesReturn: "إرجاع المبيعات",
    salesOrder: "طلب المبيعات",

    expenseAccount: "حساب المصروفات",
    expenseSupplier: "مورد المصروفات",
    expenseInvoice: "فاتورة المصروفات",

    stockControl: "مراقبة المخزون",
    stockTransfer: "تحويل المخزون",
    stockCount: "تعداد المخزون",

    products: "المنتجات",
    categories: "الفئات",
    brands: "العلامات التجارية",
    seasons: "المواسم",
    vatGroup: "مجموعة الضريبة",

    financial: "المالية",
    operational: "التشغيلية",
    stockReport: "تقرير المخزون",
    sessions: "الجلسات",
    validation: "تقرير التحقق",

    //tools
    stockTools: "أدوات المخزون",
    openingYear: "السنة الافتتاحية",
    posTools: "أدوات نقطة البيع",
    import: "استيراد",
    backup: "النسخ الاحتياطي",

    //settings
    general: "الإعدادات العامة",
    user: "المستخدم",
    role: "الدور",
    linkAccount: "ربط الحساب",
    currency: "العملة",

    //retail
    pos: "نقطة البيع",
};

const frenchPages = {
    salesDashboard: "Tableau des ventes",
    chartOfAccount: "Plan comptable",
    myAccounts: "Mes comptes",
    groups: "Groupes",
    delivery: "Livraison",

    cashAccount: "Compte de caisse",
    varianceAccount: "Compte d'écart",
    cashTransfer: "Transfert de fonds",
    payments: "Paiements",
    receipts: "Reçus",

    employee: "Employé",
    salary: "Salaire",

    supplier: "Fournisseur",
    purchaseInvoice: "Facture d'achat",
    purchaseReturn: "Retour d'achat",
    purchaseOrder: "Commande d'achat",

    customer: "Client",
    salesInvoice: "Facture de vente",
    salesReturn: "Retour de vente",
    salesOrder: "Commande de vente",

    expenseAccount: "Compte de dépenses",
    expenseSupplier: "Fournisseur de dépenses",
    expenseInvoice: "Facture de dépenses",

    stockControl: "Contrôle de stock",
    stockTransfer: "Transfert de stock",
    stockCount: "Inventaire",

    products: "Produits",
    categories: "Catégories",
    brands: "Marques",
    seasons: "Saisons",
    vatGroup: "Groupe TVA",

    financial: "Financier",
    operational: "Opérationnel",
    stockReport: "Rapport de stock",
    sessions: "Sessions",
    validation: "Validations",

    stockTools: "Outils de stock",
    openingYear: "Année d'ouverture",
    posTools: "Outils POS",
    import: "Importer",
    backup: "Sauvegarde",

    general: "Général",
    user: "Utilisateur",
    role: "Rôle",
    linkAccount: "Lier un compte",
    currency: "Devise",

    pos: "Point de vente",
};

const spanishPages = {
    salesDashboard: "Panel de ventas",
    chartOfAccount: "Plan de cuentas",
    myAccounts: "Mis cuentas",
    groups: "Grupos",
    delivery: "Entrega",

    cashAccount: "Cuenta de efectivo",
    varianceAccount: "Cuenta de variación",
    cashTransfer: "Transferencia de efectivo",
    payments: "Pagos",
    receipts: "Recibos",

    employee: "Empleado",
    salary: "Salario",

    supplier: "Proveedor",
    purchaseInvoice: "Factura de compra",
    purchaseReturn: "Devolución de compra",
    purchaseOrder: "Orden de compra",

    customer: "Cliente",
    salesInvoice: "Factura de venta",
    salesReturn: "Devolución de venta",
    salesOrder: "Orden de venta",

    expenseAccount: "Cuenta de gastos",
    expenseSupplier: "Proveedor de gastos",
    expenseInvoice: "Factura de gastos",

    stockControl: "Control de inventario",
    stockTransfer: "Transferencia de stock",
    stockCount: "Conteo de stock",

    products: "Productos",
    categories: "Categorías",
    brands: "Marcas",
    seasons: "Temporadas",
    vatGroup: "Grupo IVA",

    financial: "Financiero",
    operational: "Operativo",
    stockReport: "Informe de inventario",
    sessions: "Sesiones",
    validation: "Validaciones",

    stockTools: "Herramientas de inventario",
    openingYear: "Apertura del año",
    posTools: "Herramientas POS",
    import: "Importar",
    backup: "Copia de seguridad",

    general: "General",
    user: "Usuario",
    role: "Rol",
    linkAccount: "Vincular cuenta",
    currency: "Moneda",

    pos: "Punto de venta",
};

const portuguesePages = {
    salesDashboard: "Painel de vendas",
    chartOfAccount: "Plano de contas",
    myAccounts: "Minhas contas",
    groups: "Grupos",
    delivery: "Entrega",

    cashAccount: "Conta de caixa",
    varianceAccount: "Conta de variação",
    cashTransfer: "Transferência de caixa",
    payments: "Pagamentos",
    receipts: "Recibos",

    employee: "Funcionário",
    salary: "Salário",

    supplier: "Fornecedor",
    purchaseInvoice: "Fatura de compra",
    purchaseReturn: "Devolução de compra",
    purchaseOrder: "Pedido de compra",

    customer: "Cliente",
    salesInvoice: "Fatura de venda",
    salesReturn: "Devolução de venda",
    salesOrder: "Pedido de venda",

    expenseAccount: "Conta de despesas",
    expenseSupplier: "Fornecedor de despesas",
    expenseInvoice: "Fatura de despesas",

    stockControl: "Controle de estoque",
    stockTransfer: "Transferência de estoque",
    stockCount: "Contagem de estoque",

    products: "Produtos",
    categories: "Categorias",
    brands: "Marcas",
    seasons: "Temporadas",
    vatGroup: "Grupo de IVA",

    financial: "Financeiro",
    operational: "Operacional",
    stockReport: "Relatório de estoque",
    sessions: "Sessões",
    validation: "Validações",

    stockTools: "Ferramentas de estoque",
    openingYear: "Ano de abertura",
    posTools: "Ferramentas POS",
    import: "Importar",
    backup: "Backup",

    general: "Geral",
    user: "Usuário",
    role: "Função",
    linkAccount: "Vincular conta",
    currency: "Moeda",

    pos: "Ponto de venda",
};

const brazilianPortuguesePages = {
    salesDashboard: "Painel de Vendas",
    chartOfAccount: "Plano de Contas",
    myAccounts: "Minhas Contas",
    groups: "Grupos",
    delivery: "Entrega",

    cashAccount: "Conta de Caixa",
    varianceAccount: "Conta de Diferença",
    cashTransfer: "Transferência de Caixa",
    payments: "Pagamentos",
    receipts: "Recebimentos",

    employee: "Funcionário",
    salary: "Folha de Pagamento",

    supplier: "Fornecedor",
    purchaseInvoice: "Nota Fiscal de Compra",
    purchaseReturn: "Devolução de Compra",
    purchaseOrder: "Pedido de Compra",

    customer: "Cliente",
    salesInvoice: "Nota Fiscal de Venda",
    salesReturn: "Devolução de Venda",
    salesOrder: "Pedido de Venda",

    expenseAccount: "Conta de Despesa",
    expenseSupplier: "Fornecedor de Despesa",
    expenseInvoice: "Nota Fiscal de Despesa",

    stockControl: "Controle de Estoque",
    stockTransfer: "Transferência de Estoque",
    stockCount: "Contagem de Estoque",

    products: "Produtos",
    categories: "Categorias",
    brands: "Marcas",
    seasons: "Temporadas",
    vatGroup: "Grupo de Impostos",

    financial: "Financeiro",
    operational: "Operacional",
    stockReport: "Relatório de Estoque",
    sessions: "Sessões",
    validation: "Validações",

    // Ferramentas
    stockTools: "Ferramentas de Estoque",
    openingYear: "Ano de Abertura",
    posTools: "Ferramentas do PDV",
    import: "Importar",
    backup: "Backup",

    // Configurações
    general: "Geral",
    user: "Usuário",
    role: "Função",
    linkAccount: "Vincular Conta",
    currency: "Moeda",

    // PDV
    pos: "PDV",
};



export {
    englishTabs,
    arabicTabs,
    frenchTabs,
    portugueseTabs,
    spanishTabs,
    brazilianPortugueseTabs,

    englishPages,
    arabicPages,
    frenchPages,
    portuguesePages,
    spanishPages,
    brazilianPortuguesePages,
};